module.exports = __webpack_public_path__ + "img/ppl.2140e063.png";